import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';

export default function Jobs() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'الكل', icon: 'ri-apps-line' },
    { id: 'events', name: 'فعاليات', icon: 'ri-calendar-event-line' },
    { id: 'retail', name: 'تجارة', icon: 'ri-store-line' },
    { id: 'hospitality', name: 'ضيافة', icon: 'ri-restaurant-line' },
    { id: 'tech', name: 'تقنية', icon: 'ri-computer-line' }
  ];

  const jobs = [
    {
      id: 1,
      title: 'مضيف في معرض الرياض الدولي',
      company: 'شركة المعارض السعودية',
      location: 'الرياض',
      salary: '150 ريال/يوم',
      duration: '3 أيام',
      category: 'events',
      image: 'https://public.readdy.ai/ai/img_res/f62ea74260e627bebf4ccf1ad90998ef.jpg',
      urgent: true,
      requirements: ['خبرة في خدمة العملاء', 'إجادة اللغة الإنجليزية', 'مظهر لائق']
    },
    {
      id: 2,
      title: 'كاشير في متجر إلكترونيات',
      company: 'إكسترا السعودية',
      location: 'جدة',
      salary: '120 ريال/يوم',
      duration: '5 أيام',
      category: 'retail',
      image: 'https://readdy.ai/api/search-image?query=Modern%20electronics%20store%20interior%2C%20clean%20organized%20shelves%20with%20gadgets%2C%20bright%20retail%20environment%2C%20professional%20cashier%20counter%2C%20contemporary%20design&width=400&height=200&seq=job2&orientation=landscape',
      urgent: false,
      requirements: ['خبرة في نقاط البيع', 'دقة في التعامل مع المال', 'مهارات تواصل جيدة']
    },
    {
      id: 3,
      title: 'نادل في مطعم فاخر',
      company: 'مطاعم الأصالة',
      location: 'الدمام',
      salary: '180 ريال/يوم',
      duration: '7 أيام',
      category: 'hospitality',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20restaurant%20interior%20with%20fine%20dining%20setup%2C%20professional%20waiter%20serving%2C%20luxury%20ambiance%2C%20warm%20lighting%2C%20sophisticated%20table%20setting&width=400&height=200&seq=job3&orientation=landscape',
      urgent: false,
      requirements: ['خبرة في المطاعم', 'مهارات خدمة متميزة', 'القدرة على العمل تحت الضغط']
    },
    {
      id: 4,
      title: 'مطور تطبيقات مؤقت',
      company: 'تك سوليوشنز',
      location: 'الرياض',
      salary: '300 ريال/يوم',
      duration: '10 أيام',
      category: 'tech',
      image: 'https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20developer%20coding%20on%20computer%2C%20clean%20desk%20setup%2C%20multiple%20monitors%2C%20professional%20tech%20environment%2C%20bright%20lighting&width=400&height=200&seq=job4&orientation=landscape',
      urgent: true,
      requirements: ['خبرة في React Native', 'معرفة بـ TypeScript', 'القدرة على العمل بشكل مستقل']
    }
  ];

  const filteredJobs = jobs.filter(job => {
    const matchesSearch = job.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         job.company.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || job.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <TopNavigation 
        title="الوظائف المتاحة"
        leftAction={
          <button 
            onClick={() => navigate('/dashboard')}
            className="w-8 h-8 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        }
        rightAction={
          <button className="w-8 h-8 flex items-center justify-center">
            <i className="ri-filter-line text-lg"></i>
          </button>
        }
      />

      <div className="pt-14 pb-20 px-4">
        {/* Search Bar */}
        <div className="mb-6 mt-4">
          <Input
            placeholder="ابحث عن وظيفة..."
            icon="ri-search-line"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Categories */}
        <div className="mb-6">
          <div className="flex gap-3 overflow-x-auto pb-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedCategory === category.id
                    ? 'bg-[#1565C0] text-white'
                    : 'bg-white text-[#607D8B] border border-gray-200'
                }`}
              >
                <i className={`${category.icon} ml-2`}></i>
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="mb-6">
          <Card className="bg-gradient-to-r from-[#1565C0] to-[#1976D2] text-white">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="text-lg font-semibold">وظائف متاحة اليوم</h3>
                <p className="text-white/90 text-sm">{filteredJobs.length} وظيفة</p>
              </div>
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                <i className="ri-briefcase-line text-xl"></i>
              </div>
            </div>
          </Card>
        </div>

        {/* Jobs List */}
        <div className="space-y-4">
          {filteredJobs.map((job) => (
            <Card 
              key={job.id} 
              className="hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => navigate(`/jobs/${job.id}`)}
            >
              <div className="space-y-4">
                {/* Job Image */}
                <div className="relative h-32 rounded-lg overflow-hidden">
                  <img 
                    src={job.image} 
                    alt={job.title}
                    className="w-full h-full object-cover object-top"
                  />
                  {job.urgent && (
                    <div className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                      عاجل
                    </div>
                  )}
                </div>

                {/* Job Info */}
                <div>
                  <h3 className="font-semibold text-[#333333] text-lg mb-1">{job.title}</h3>
                  <p className="text-[#607D8B] text-sm mb-2">{job.company}</p>
                  
                  <div className="flex items-center gap-4 mb-3">
                    <div className="flex items-center text-[#757575] text-sm">
                      <i className="ri-map-pin-line ml-1"></i>
                      {job.location}
                    </div>
                    <div className="flex items-center text-[#757575] text-sm">
                      <i className="ri-time-line ml-1"></i>
                      {job.duration}
                    </div>
                  </div>

                  <div className="flex items-center justify-between mb-3">
                    <span className="text-[#4CAF50] font-semibold text-lg">{job.salary}</span>
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-[#4CAF50] rounded-full"></div>
                      <span className="text-[#4CAF50] text-sm">متاح الآن</span>
                    </div>
                  </div>

                  {/* Requirements */}
                  <div className="mb-4">
                    <h4 className="text-sm font-medium text-[#333333] mb-2">المتطلبات:</h4>
                    <div className="flex flex-wrap gap-2">
                      {job.requirements.map((req, index) => (
                        <span 
                          key={index}
                          className="px-2 py-1 bg-[#F5F5F5] text-[#607D8B] text-xs rounded-full"
                        >
                          {req}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="flex gap-3">
                    <Button 
                      variant="primary" 
                      className="flex-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/jobs/${job.id}`);
                      }}
                    >
                      تقدم الآن
                    </Button>
                    <button 
                      className="w-12 h-12 border border-gray-200 rounded-lg flex items-center justify-center hover:bg-gray-50"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="ri-heart-line text-[#607D8B]"></i>
                    </button>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {filteredJobs.length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-[#F5F5F5] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-search-line text-[#607D8B] text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-[#333333] mb-2">لا توجد وظائف</h3>
            <p className="text-[#757575]">جرب البحث بكلمات مختلفة أو غير الفئة</p>
          </div>
        )}
      </div>

      <BottomNavigation />
    </div>
  );
}
